import React from 'react'
import { AIDemoSection } from '../components/AIHero'
import DemoForm from '../components/DemoForm'
import { AnimatedPage } from '../components/AnimatedPage'

export const AIDemo = () => {
  return (
    <AnimatedPage>
    <AIDemoSection/>
    <DemoForm/>
    </AnimatedPage>
  )
}
